import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";

import { Influencer } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import {
  INFLUENCER_LIST_QUERY_KEY,
  SOCIAL_MEDIA_INFLUENCER_QUERY_KEY,
} from "../constants";

export function useDeLinkSocialMedia(
  handleUpdate?: (influencer: Influencer) => void
) {
  const {
    mutate: deLinkSocialMedia,
    isLoading: isDelinking,
    isSuccess: isDelinked,
  } = useMutation<
    { influencerId: string; socialMediaLinkageId: string },
    BackednResponse<Influencer> | void
  >({
    mutationFn: async ({ influencerId, socialMediaLinkageId }) => {
      return await InfluencerService.deLinkSocialMedia(
        influencerId,
        socialMediaLinkageId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data) => {
      c.invalidateQueries({
        queryKey: [...SOCIAL_MEDIA_INFLUENCER_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, data?.data?.influencerId],
      });
      if (data?.data) {
        handleUpdate?.(data.data);
      }
    },
  });

  return {
    deLinkSocialMedia,
    isDelinking,
    isDelinked,
  };
}
